<template>
    <div>
      <template v-for="info in satsangiinfo">
      <b-card no-body class="overflow-hidden" style="max-width: 540px;" header-tag="header" footer-tag="footer">
        <template #header>
         <h6 class="text-center" style="margin-top:0px;margin-bottom:0px;"><b>Radhasomi</b></h6>
         <hr style="margin-top:0px;margin-bottom:0px;"/>
         <h5 class="text-center" style="margin-top:0px;margin-bottom:0px;"><b>Bhandarghar Meal Card</b></h5>
         <b-card-text class="text-center" style="margin-top:0px;margin-bottom:0px;">
           Radhasoami Satsang, Soamibagh, Agra
        </b-card-text>
        <hr style="margin-top:0px;margin-bottom:0px;"/>
       </template>
       <b-row no-gutters>
         <b-col sm="10">
           <b-card-body style="margin-top:0px;margin-bottom:0px;padding-top:0px;padding-bottom:0px;">
             <b-card-text style="margin-top:0px;margin-bottom:0px;font-size:15px;">
               <b>Name:</b> {{info['name']}}
             </b-card-text>
             <b-card-text style="margin-top:0px;margin-bottom:0px;">
               <b>Card No:</b> {{info['idcard']}}
             </b-card-text>
             <b-card-text style="margin-top:0px;margin-bottom:0px;">
               <b-row>
                 <b-col><b>Mobile No:</b> {{info['phone']}}</b-col>              
               </b-row>
             </b-card-text>            
           </b-card-body>
        </b-col>
  
       </b-row>
       <b-table style="margin-top:0px;margin-bottom:0px;" small :items="mealDates" :fields="fields" id="dataTable" ref="dataTable" responsive="sm">
         <template #cell(date)="data">
           <b class="text-info">{{ data.value }}</b>
         </template>
         <template #cell(lunch)="data">
           <b class="text-info">{{ data.value }}</b>
         </template>
         <template #cell(dinner)="data">
           <b class="text-info">{{ data.value }}</b>
         </template>
      </b-table>
  
      <b-card-footer style="margin-top:0px;margin-bottom:0px;padding-top:0px;padding-bottom:0px;">
         <span>Authority Signature</span>
      </b-card-footer>
      <br/>
      <br/>
     </b-card>
     </template>
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  export default {
    name: 'MealPrintCard',
  
    data: function () {
      return {
        meals:[],
        arrivaldate: null,
        departuredate: null,
        satsangiinfo: [],
        mealDates: [],
        fields: [
  
                    {key:'date', label:'Date'},
                    {key:'lunch', label:'Lunch'}, {key:'dinner', label:'Dinner'},
  
  
                ],
  
        //{"date":"2021-09-01",vtype:"Name of Vaccinae", dose:1},{}
      };
    },
    methods: {
      setCardData(meals,arrivaldate, departuredate, satsangiinfo){
        this.meals = meals;
        this.arrivaldate = arrivaldate;
        this.departuredate = departuredate;        
        this.satsangiinfo = satsangiinfo;

        let reservationDates = this.getDates(this.arrivaldate, this.departuredate);
        reservationDates.forEach((rerserveDate) =>{
            let record = {
                'date': rerserveDate,
                'lunch': 'N',
                'dinner': 'N'
            }
            if(meals['L'] != null && meals['L'].includes(rerserveDate)) {
                record['lunch'] = 'Y';
            }
            if(meals['D'] != null && meals['D'].includes(rerserveDate)) {
                record['dinner'] = 'Y';
            }
            this.mealDates.push(record);
        }, this)

        console.log(this.mealDates);
      },
      resetData(){
        this.mealDates = [];    
        this.satsangiinfo = []   
  
      }
    }
  }
  
  </script>
  